module.exports = __webpack_public_path__ + "img/Frank_Napp.265e68ad.jpg";